var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 18.2812L8.71875 13.5312C8.59375 13.375 8.5 13.1875 8.5 13C8.5 12.8438 8.59375 12.6562 8.71875 12.5L13.1875 7.75C13.4688 7.4375 13.9375 7.4375 14.25 7.71875C14.5625 8 14.5625 8.46875 14.2812 8.78125L10.25 13.0312L14.2812 17.25C14.5625 17.5625 14.5625 18.0312 14.25 18.3125C13.9375 18.5938 13.4688 18.5938 13.1875 18.2812Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/AngleLeft.ff723022f95cee8b66f7ba402f5876d7.svg";
export { ForwardRef as ReactComponent };